<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">🚀 胸怀远景，步履不休</p>

        <p class="p5">以日复一日的精进打磨能力，</p>
        <p class="p6">在攀登中看见更远的风景。</p>
    
        <div style="width: 82%;margin: 0 auto;">
            <p class="p6" style="padding-top: 5vh;">2025年你的个人发展与成长：</p>
            <p class="p6" v-if="this.count!=0" style="padding-top: 1vh;"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.count }}</a>个认证培训项目学习</p>
            <p class="p6" v-if="this.count1!=0"> <i class="fa fa-check"></i>获得了<a class="font3">{{ this.count1 }}</a>个证书</p>
            <div>
                <p class="p6" v-if="this.course!==''"> <i class="fa fa-check"></i>完成了<a class="highlight">{{ this.course }}</a></p>
                <p class="p6" v-if="this.promote!==''"> <i class="fa fa-check"></i>顺利晋升为<a class="highlight">{{ this.promote }}</a></p>
                <p class="p6" v-if="this.teacher!==''"> <i class="fa fa-check"></i>通过讲师认证，成为<a class="highlight">{{ this.teacher }}</a></p>
            </div> 
        </div>

    </div>
</template>
  
  
<script>
    export default {
        props: [ "ReportData"],
        data(){
            return {
                activityArray:[],
                course:'',
                promote:'',
                teacher:'',
                count:0,
                count1:0,
            }
        },
        created(){
            const activityArray = JSON.parse(this.ReportData.activity2)
            // const activityArray1 = JSON.parse(this.ReportData.activity)
            // this.count=activityArray1.length
            activityArray.forEach(element => {
               if(element.name=='讲师评审'){
                    this.teacher=element.certificate
               }else if(element.name=='晋升'){
                    this.promote=element.certificate
               }else{
                    this.course=element.certificate
               }
            });
          
           
        }
    }
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg1.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  .highlight {
    font-size: 26px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Year/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 30px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
}
</style>